import createStyles from "@mui/styles/createStyles";
import {makeStyles} from "@mui/styles";

export default makeStyles(() => createStyles({

}));
